/* global fetch */
import 'isomorphic-fetch'
import { normalize } from 'normalizr'
import { camelizeKeys, decamelizeKeys } from 'humps'

import { getAuthToken } from 'utils/auth'
import * as qs from 'utils/querystring'

export const API_ROOT = process.env.API_ROOT || 'http://lvh.me:3000/v1/'

function decamelizeQuerystring (url) {
  const [beforeQuerystring, querystring] = url.split('?')

  if (!querystring) {
    return url
  }

  const queryobject = qs.parse(querystring)
  const decamelizedQueryobject = decamelizeKeys(queryobject)
  const decamelizedQuerystring = qs.stringify(decamelizedQueryobject, true)

  return beforeQuerystring + decamelizedQuerystring
}

export function createRequest (endpoint, options) {
  const {
    method = 'GET',
    body,
    headers,
    requiresAuth = false,
    removeVersionFromUrl = false,
    credentials = 'same-origin'
  } = options

  let url = endpoint.indexOf(API_ROOT) === -1
    ? API_ROOT + endpoint
    : endpoint

  url = decamelizeQuerystring(url)

  if (removeVersionFromUrl) {
    url = url.replace(/\/v\d/, '')
  }

  const request = {}

  if (body) {
    request.body = typeof body === 'object'
      ? JSON.stringify(decamelizeKeys(body))
      : body
  }

  request.method = method

  request.headers = {
    ...headers,
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }

  if (requiresAuth) {
    const authToken = getAuthToken()
    if (authToken) {
      request.headers['Authorization'] = `Bearer ${authToken}`
    }
  }

  const csrfToken = document.querySelector('meta[name="csrf-token"]')
  if (csrfToken) {
    request.headers['X-CSRF-Token'] = csrfToken.content
  }

  request.credentials = credentials

  return [url, request]
}

export function callApi (endpoint, config = {}, schema) {
  const [url, options] = createRequest(endpoint, config)

  return fetch(url, options)
    .catch((error) => {
      // If we are here, it is due to a TypeError
      const errorMessage = error.stack
      return Promise.reject(errorMessage)
    })
    .then((response) => {
      return response.json().then((json) => ({json, response}))
    })
    .then(({json, response}) => {
      if (!response.ok) {
        const { errors } = json
        const { status, statusText } = response

        const error = errors || `${status}: ${statusText}`
        return Promise.reject(error)
      }

      const camelizedJson = camelizeKeys(json, (key, convert) => {
        return key.indexOf('_') > -1 ? convert(key) : key
      })

      return schema
        ? normalize(camelizedJson, schema)
        : camelizedJson
    })
    .then(
      response => ({ response }),
      error => ({ error })
    )
}



// WEBPACK FOOTER //
// ./src/services/api/api.js